import PaymentsIcon from "@mui/icons-material/Payments";
import { tenants } from "utils/tenants";
import { resources as Budgets } from "./Budgets";
import { resources as ScholarshipCampaigns } from "./ScholarshipCampaigns";
import { resources as ScholarshipApplications } from "./ScholarshipApplications";
import { resources as ApprovedScholarships } from "./ApprovedScholarships";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <PaymentsIcon />,
  name: "Стипендии",
  title: "Стипендии",
  subMenu: [Budgets, ScholarshipCampaigns, ScholarshipApplications, ApprovedScholarships],
};
